import { DatasetInfo } from "api/model/dataset/DatasetInfo";
import { ComponentConfigDefault, DatasetDefaultConfig } from "models/dataset-models";
import { CSSProperties } from "react";

export interface IDatasetTableCommonProps {
  data: Array<any>;
  config?: ComponentConfigDefault;
  dateFrom?: Date;
  dateTo?: Date;
  datasetsArray: DatasetInfo[];
  totals: IDatasetTotal[];
  formatNumbers: boolean;
  setIsDialogOpen: (value: boolean) => void;
  forceLtTz: boolean;
}

export interface IDatasetTableDefaultProps extends Omit<IDatasetTableCommonProps, "datasetsArray"> {
  dateFrom?: Date;
  dateTo?: Date;
  getCellStyle: (date: string, obj: any) => CSSProperties | undefined;
  datasetsArray: (DatasetDefaultConfig & { stringValueMapper?: number })[];
  forceLtTz: boolean;
}

export interface IDataArray {
  [key: string]: string | number;
}

export interface IDatasetTotal {
  identifier: string;
  value?: string;
  tooltip?: string;
}

export enum DatasetTableMode {
  SINGLE = "SINGLE",
  GROUPED = "GROUPED",
}

export interface IFlattenedDataset {
  title: string;
  identifier: string;
  unit: string;
  decimalPlaces: string;
}

export interface ColumnValueBodyStyle {
  padding: string;
  color?: string;
  backgroundColor?: string;
}
